// Copyright (c) 2020 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as React from "react";
import { connect } from "react-redux";
import { WrappedComponentProps, injectIntl } from "react-intl";

import { IAction } from "actions";
import { IState } from "states/states";

import { ReactComponent as IconSearch } from "static/iconSearch.svg";
import { ReactComponent as IconClearSearch } from "static/iconZoomFit.svg";

interface ISearchFilterExtProps {
  className?: string;
  placeholder: string;
  filterText: string;
  onChange?: (searchText: string) => void;
  onFocus?: (event: any) => void;
  onBlur?: (event: any) => void;
  autoFocus?: boolean;
  tooltip?: string;
  datalist?: string;
}

interface ISearchFilterProps {}

const mapStateToProps = (state: IState, ownProps: ISearchFilterExtProps) => {
  const props: ISearchFilterProps = {};
  return props;
};

interface ISearchFilterDispatch {}

const mapDispatchToProps = (dispatch: (action: IAction<any>) => void) => {
  const dispatchProps: ISearchFilterDispatch = {};
  return dispatchProps;
};

class SearchFilterComponent extends React.Component<
  ISearchFilterProps & ISearchFilterExtProps & ISearchFilterDispatch & WrappedComponentProps
> {
  public render() {
    const keyHandler: React.KeyboardEventHandler<HTMLInputElement> = (event) => {
      if (event.key === "Escape") {
        this.props.onChange?.("");
        event.stopPropagation();
        event.preventDefault();
      }
    };

    return (
      <div className={"listSearchBox " + (this.props.className ?? "")}>
        <input
          id={"searchField_" + Math.random().toString()}
          title={this.props.tooltip}
          placeholder={this.props.placeholder}
          value={this.props.filterText}
          onChange={(event) => {
            const filterText = event?.currentTarget.value ?? "";
            this.props.onChange?.(filterText);
          }}
          onKeyDown={keyHandler}
          type="text"
          autoFocus={this.props.autoFocus ?? false}
          onFocus={(event) => this.props.onFocus?.(event)}
          onBlur={(event) => this.props.onBlur?.(event)}
          list={this.props.datalist}
        />
        {this.props.filterText !== "" ? (
          <IconClearSearch
            className="searchIcon clearable"
            width={"30px"}
            fill="red"
            onClick={(event) => {
              this.props.onChange?.("");
            }}
          />
        ) : (
          <IconSearch className="searchIcon" width={"30px"} viewBox={"5 0 35 50"} />
        )}
      </div>
    );
  }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(SearchFilterComponent));
